import { lazy } from 'react';
// project-imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import Configs from 'pages/configs/Configs';
import OrdersPageV2 from 'pages/orders/OrdersV2';
import AccessChecker from 'pages/common/AccessChecker';
// import SimulationDetailedViewPage from 'pages/simulation/simulations-detailed-view';
// import { BrowserRouter as Router, Routes, HashRouter, Route, createBrowserRouter } from 'react-router-dom';

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const DashboardAnalytics = Loadable(lazy(() => import('pages/dashboard/analytics')));

// render - forms & tables
// const FormsValidation = Loadable(lazy(() => import('pages/forms/validation')));
// const FormsWizard = Loadable(lazy(() => import('pages/forms/wizard')));

// const FormsLayoutBasic = Loadable(lazy(() => import('pages/forms/layouts/basic')));
// const FormsLayoutMultiColumn = Loadable(lazy(() => import('pages/forms/layouts/multi-column')));
// const FormsLayoutActionBar = Loadable(lazy(() => import('pages/forms/layouts/action-bar')));
// const FormsLayoutStickyBar = Loadable(lazy(() => import('pages/forms/layouts/sticky-bar')));

// const FormsPluginsMask = Loadable(lazy(() => import('pages/forms/plugins/mask')));
// const FormsPluginsClipboard = Loadable(lazy(() => import('pages/forms/plugins/clipboard')));
// const FormsPluginsRecaptcha = Loadable(lazy(() => import('pages/forms/plugins/re-captcha')));
// const FormsPluginsEditor = Loadable(lazy(() => import('pages/forms/plugins/editor')));
// const FormsPluginsDropzone = Loadable(lazy(() => import('pages/forms/plugins/dropzone')));

// // pages routing
// const AuthLogin = Loadable(lazy(() => import('pages/auth/auth1/login')));
// const AuthRegister = Loadable(lazy(() => import('pages/auth/auth1/register')));
// const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/auth1/forgot-password')));
// const AuthResetPassword = Loadable(lazy(() => import('pages/auth/auth1/reset-password')));
// const AuthCheckMail = Loadable(lazy(() => import('pages/auth/auth1/check-mail')));
// const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/auth1/code-verification')));

// const AuthLogin2 = Loadable(lazy(() => import('pages/auth/auth2/login2')));
// const AuthRegister2 = Loadable(lazy(() => import('pages/auth/auth2/register2')));
// const AuthForgotPassword2 = Loadable(lazy(() => import('pages/auth/auth2/forgot-password2')));
// const AuthResetPassword2 = Loadable(lazy(() => import('pages/auth/auth2/reset-password2')));
// const AuthCheckMail2 = Loadable(lazy(() => import('pages/auth/auth2/check-mail2')));
// const AuthCodeVerification2 = Loadable(lazy(() => import('pages/auth/auth2/code-verification2')));

// const AuthLogin3 = Loadable(lazy(() => import('pages/auth/auth3/login3')));

// const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/error/404')));
// const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/error/500')));
// const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction/under-construction')));
// const MaintenanceUnderConstruction2 = Loadable(lazy(() => import('pages/maintenance/under-construction/under-construction2')));
// const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon/coming-soon')));
// const MaintenanceComingSoon2 = Loadable(lazy(() => import('pages/maintenance/coming-soon/coming-soon2')));

// // render - sample page
// const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
// const Landing = Loadable(lazy(() => import('pages/landing')));
// const ContactUS = Loadable(lazy(() => import('pages/contact-us')));
// const PricingPage = Loadable(lazy(() => import('pages/extra-pages/price/price1')));
// const PricingPage2 = Loadable(lazy(() => import('pages/extra-pages/price/price2')));

//* CUSTOM PAGES
const HistoricalPrices = Loadable(lazy(() => import('pages/prices/historical-stock-prices')));
// const UsersPage = Loadable(lazy(() => import('pages/users/Users')));
const CompleteUsersPage = Loadable(lazy(() => import('pages/complete-users/CompleteUsers')));
const InCompleteUsersPage = Loadable(lazy(() => import('pages/incomplete-users/IncompleteUsers')));
const StrategyListPage = Loadable(lazy(() => import('pages/strategies/strategy-list')));
const SimulationsPage = Loadable(lazy(() => import('pages/simulation/simulations')));
const LiveSimulationPage = Loadable(lazy(() => import('pages/simulation/live-simulation')));
const TradeSchedulePage = Loadable(lazy(() => import('pages/trade-schedule/TradeSchedulePage')));
const RecommendationPage = Loadable(lazy(() => import('pages/simulation/recommendations')));
const RecommendationList = Loadable(lazy(() => import('pages/recommendation-v2/RecommendationMasterList')));

const SimulationDetailedViewPage = Loadable(lazy(() => import('pages/simulation/simulations-detailed-view')));
const LiveSimulationDetailedViewPageV2 = Loadable(lazy(() => import('pages/simulationV2/live-simulation-detailed-view')));

const RecommendationSimulationDetailedViewPage = Loadable(lazy(() => import('pages/simulation/recommendation-detailed-view')));
const RecommendationSimulationDetailedViewPageV2 = Loadable(lazy(() => import('pages/recommendation-v2/recommendations-detailed-view')));

const HistoricDataPage = Loadable(lazy(() => import('pages/historic-data/HistoricData')));

// const OrdersPage = Loadable(lazy(() => import('pages/orders/Orders')));
const StockGroupPage = Loadable(lazy(() => import('pages/stocks/StockGroupPage')));
const Roles = Loadable(lazy(() => import('pages/roles/rolespage')));
const MarketHolidays = Loadable(lazy(() => import('pages/market-holidays/MarketHolidays')));
const MarketEvents = Loadable(lazy(() => import('pages/market-event/MarketEvents')));
const Appsettings = Loadable(lazy(() => import('pages/app-settings/appsettings')));
const EmpoloyeesPage = Loadable(lazy(() => import('pages/employees/EmpoloyeesPage')));
const AdminLogsPage = Loadable(lazy(() => import('pages/adminlogs/AdminLogs')));
const OrdersPositionsPage = Loadable(lazy(() => import('pages/order-positions/OrderPositionsPage')));
const BrokersPage = Loadable(lazy(() => import('pages/brokers/BrokersPage')));
const InstrumentsPage = Loadable(lazy(() => import('pages/instruments/InstrumentsPage')));
const DecisionLogsPage = Loadable(lazy(() => import('pages/decisionlogs/DecisionLogs')));
const OrderRequestHistoryPage = Loadable(lazy(() => import('pages/order-requests/OrderRequestHistory')));
const RecommendationDecisionPage = Loadable(lazy(() => import('pages/recommedaton-decision/RecommendationDecision')));
const DeleteRequestsPage = Loadable(lazy(() => import('pages/delete-request/ListDeleteRequests')));
const DailyTasksPage = Loadable(lazy(() => import('pages/daily-tasks/DailyTasks')));
const LiveTickStatusPage = Loadable(lazy(() => import('pages/live-tick-status/LiveTickStatusPage')));
const SubscriptionsPage = Loadable(lazy(() => import('pages/live-tick-status/SubscriptionsPage')));
const TickStorePage = Loadable(lazy(() => import('pages/tick-store/TickStorePage')));
const NoTradeIndicatorPage = Loadable(lazy(() => import('pages/no-trade-indicator/NoTradeIndicator')));
const SectorPerformancePage = Loadable(lazy(() => import('pages/sector-performance/SectorPerformance')));
const SmcWatchPage = Loadable(lazy(() => import('pages/smc-watch/SmcWatch')));
const OrderFlowPage = Loadable(lazy(() => import('pages/order-flow/OrderFlowPage')));
const NiftyOptionChainPage = Loadable(lazy(() => import('pages/nifty-option-chain/NiftyOptionChain')));
const WeeklyReportsPage = Loadable(lazy(() => import('pages/reports/WeeklyReports')));
const DailyReportsPage = Loadable(lazy(() => import('pages/reports/DailyReports')));
const SensexOptionChainPage = Loadable(lazy(() => import('pages/sensex-option-chain/SensexOptionChain')));
const MarketCharacterPage = Loadable(lazy(() => import('pages/market-character/MarketCharacterPage')));
const DailyPatternMatchPage = Loadable(lazy(() => import('pages/daily-pattern-match/DailyPatternMatchPage')));
const PatternV1ListPage = Loadable(lazy(() => import('pages/pattern-v1/PatternV1ListPage')));
const PatternV2Page = Loadable(lazy(() => import('pages/pattern-v2/PatternV2')));
const SubscriptionPlansPage = Loadable(lazy(() => import('pages/subscription-plans/SubscriptionPlansPage')));
const PatternV1DetailPage = Loadable(lazy(() => import('pages/pattern-v1/PatternV1DetailPage')));

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'dashboard',
          children: [
            {
              path: 'default',
              element: <DashboardDefault />
            },
            {
              path: 'analytics',
              element: <DashboardAnalytics />
            }
          ]
        },
        // {
        //   path: 'users',
        //   element: (
        //     <>
        //       <AccessChecker requiredPermissions={['canViewUsers']}>
        //         <UsersPage />
        //       </AccessChecker>
        //     </>
        //   )
        // },
        {
          path: 'users/complete',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewUsers']}>
                <CompleteUsersPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'users/incomplete',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewUsers']}>
                <InCompleteUsersPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'orders',
          // element: <OrdersPage />,
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewOrders']}>
                <OrdersPageV2 />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'employees',
          element: (
            <>
              <AccessChecker userType={'ADMIN'}>
                <EmpoloyeesPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'order-positions',
          element: <OrdersPositionsPage />
        },
        {
          path: 'historical-prices',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewStocks']}>
                <HistoricalPrices />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'stock-groups',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewStocks']}>
                <StockGroupPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'strategies',
          element: <StrategyListPage />
        },
        {
          path: 'simulations',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewBacktests']}>
                <SimulationsPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'simulations/:simulationId',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewBacktests']}>
                <SimulationDetailedViewPage />
              </AccessChecker>
            </>
          )
        },

        {
          path: 'trade-schedule',
          element: (
            <AccessChecker requiredPermissions={['canViewLiveTrade']}>
              <TradeSchedulePage />
            </AccessChecker>
          )
        },
        {
          path: 'live-simulations',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewLiveTrade']}>
                <LiveSimulationPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'recommendations',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewLiveTrade']}>
                <RecommendationPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'recommendation-list',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewLiveTrade']}>
                <RecommendationList />
              </AccessChecker>
            </>
          )
        },
        // {
        //   path: 'live-simulations/:simulationId',
        //   element: (
        //     <>
        //       <AccessChecker requiredPermissions={['canViewLiveTrade']}>
        //         <LiveSimulationDetailedViewPage />
        //       </AccessChecker>
        //     </>
        //   )
        // },
        {
          path: 'reports/weekly',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewReports']}>
                <WeeklyReportsPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'reports/daily',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewReports']}>
                <DailyReportsPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'live-simulations-v2/:simulationId',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewLiveTrade']}>
                <LiveSimulationDetailedViewPageV2 />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'recommendation-simulations-v2/:simulationId',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewLiveTrade']}>
                <RecommendationSimulationDetailedViewPageV2 />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'recommendation-simulations/:simulationId',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewLiveTrade']}>
                <RecommendationSimulationDetailedViewPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'historic-data',
          element: (
            <>
              <HistoricDataPage />
            </>
          )
        },

        {
          path: '/configs',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewConfig']}>
                <Configs />
              </AccessChecker>
            </>
          )
        },

        {
          path: 'roles',
          element: (
            <>
              <AccessChecker userType={'ADMIN'}>
                <Roles />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'market-holidays',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewMarketHolidays']}>
                <MarketHolidays />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'market-events',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewMarketEvents']}>
                <MarketEvents />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'app-settings',
          element: (
            <>
              <AccessChecker requiredPermissions={['canViewAppSettings']}>
                <Appsettings />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'admin-logs',
          element: (
            <>
              <AccessChecker userType={'ADMIN'}>
                <AdminLogsPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'order-requests',
          element: (
            <>
              <AccessChecker userType={'ADMIN'}>
                <OrderRequestHistoryPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'decision-logs',
          element: (
            <>
              <AccessChecker userType={'ADMIN'}>
                <DecisionLogsPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'recommendation-decision',
          element: (
            <>
              <AccessChecker userType={'ADMIN'}>
                <RecommendationDecisionPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'brokers',
          element: (
            <>
              <AccessChecker userType={'ADMIN'}>
                <BrokersPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'instruments',
          element: <InstrumentsPage />
        },
        {
          path: 'market-character',
          element: <MarketCharacterPage />
        },
        {
          path: 'daily-pattern-match',
          element: <DailyPatternMatchPage />
        },
        {
          path: 'pattern-v1',
          element: <PatternV1ListPage />
        },
        {
          path: 'pattern-v2',
          element: <PatternV2Page />
        },
        {
          path: 'subscription-plans',
          element: <SubscriptionPlansPage />
        },
        {
          path: 'pattern-v1/:stockId',
          element: <PatternV1DetailPage />
        },
        {
          path: 'delete-requests',
          element: <DeleteRequestsPage />
        },
        {
          path: 'daily-tasks',
          element: (
            <>
              <AccessChecker userType={'ADMIN'}>
                <DailyTasksPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'no-trade-indicator',
          element: (
            <>
              <NoTradeIndicatorPage />
            </>
          )
        },
        {
          path: 'sector-performance',
          element: <SectorPerformancePage />
        },
        {
          path: 'smc-watch',
          element: <SmcWatchPage />
        },
        {
          path: 'order-flow',
          element: <OrderFlowPage />
        },
        {
          path: 'nifty-option-chain',
          element: <NiftyOptionChainPage />
        },
        {
          path: 'sensex-option-chain',
          element: <SensexOptionChainPage />
        },
        {
          path: 'live-tick-status',
          element: (
            <>
              <AccessChecker userType={'ADMIN'}>
                <LiveTickStatusPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'subscriptions',
          element: (
            <>
              <AccessChecker userType={'ADMIN'}>
                <SubscriptionsPage />
              </AccessChecker>
            </>
          )
        },
        {
          path: 'tick-store',
          element: (
            <>
              <AccessChecker userType={'ADMIN'}>
                <TickStorePage />
              </AccessChecker>
            </>
          )
        }
      ]
    }
  ]
};

export default MainRoutes;
